import ModelPage from '@/pages/ModelPage.vue'

export default [
  {
    path: '/',
    name: 'model',
    component: ModelPage
  },

  {
    path: '/thank-you',
    name: 'thank-you',
    component: () => import(/* webpackChunkName: "thank-you" */ '@/pages/ThankYouPage.vue')
  },

  {
    path: '/policy',
    name: 'pocily',
    component: () => import(/* webpackChunkName: "policy" */ '@/pages/PolicyPage.vue')
  },

  {
    path: '/marketing',
    name: 'marketing',
    component: () => import(/* webpackChunkName: "marketing" */ '@/pages/MarketingPage.vue')
  },

  {
    path: '/not-found',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '@/pages/NotFoundPage.vue')
  },

  {
    path: '/:model',
    name: 'year',
    component: () => import(/* webpackChunkName: "year" */ '@/pages/YearPage.vue')
  },

  {
    path: '/:model/:year',
    name: 'modification',
    component: () => import(/* webpackChunkName: "modification" */ '@/pages/ModificationPage.vue')
  },

  {
    path: '/:model/:year/:modification',
    name: 'tech-map',
    component: () => import(/* webpackChunkName: "tech-map" */ '@/pages/TechMapPage.vue')
  },

  {
    path: '/:model/:year/:modification/service-request',
    name: 'service-request',
    component: () => import(/* webpackChunkName: "service-request" */ '@/pages/ServiceRequestPage.vue')
  },

  {
    path: '*',
    redirect: '/not-found'
  }
]
